import * as ko from 'knockout'
import template from './trot.finisher.tpl.html'
import { Params, TrotFinisherViewModel } from './TrotFinisherViewModel'

if (!ko.components.isRegistered('trot-finisher')) {
  ko.components.register('trot-finisher', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new TrotFinisherViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
